/* tslint:disable */
/* eslint-disable */
/**
 * Evidencna aplikacia API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Organizacia
 */
export interface Organizacia {
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'skratenyNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'uplnyNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'ldapUuid'?: string;
}
/**
 * 
 * @export
 * @interface PripomienkaFilter
 */
export interface PripomienkaFilter {
    /**
     * 
     * @type {string}
     * @memberof PripomienkaFilter
     */
    'hladanyVyraz'?: string;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaFilter
     */
    'datumDoruceniaOd'?: string;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaFilter
     */
    'datumDoruceniaDo'?: string;
    /**
     * 
     * @type {Array<TypPripomienkyEnum>}
     * @memberof PripomienkaFilter
     */
    'typyPripomienok'?: Array<TypPripomienkyEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PripomienkaFilter
     */
    'pripomienkujuceSubjekty'?: Array<string>;
    /**
     * 
     * @type {Array<StavPripomienkyEnum>}
     * @memberof PripomienkaFilter
     */
    'vyhodnotenia'?: Array<StavPripomienkyEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PripomienkaFilter
     */
    'priradeniPouzivatelia'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PripomienkaFilter
     */
    'nepriradenyPouzivatel'?: boolean;
}
/**
 * 
 * @export
 * @interface SprievodnyDokumentStatus
 */
export interface SprievodnyDokumentStatus {
    /**
     * 
     * @type {SprievodnyDokumentStatusEnum}
     * @memberof SprievodnyDokumentStatus
     */
    'status'?: SprievodnyDokumentStatusEnum;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SprievodnyDokumentStatusEnum = {
    Exists: 'DOCUMENT_EXISTS',
    NotFound: 'DOCUMENT_NOT_FOUND'
} as const;

export type SprievodnyDokumentStatusEnum = typeof SprievodnyDokumentStatusEnum[keyof typeof SprievodnyDokumentStatusEnum];


/**
 * 
 * @export
 * @interface Stadium
 */
export interface Stadium {
    /**
     * 
     * @type {StadiumMaterialuEnum}
     * @memberof Stadium
     */
    'hodnota': StadiumMaterialuEnum;
    /**
     * 
     * @type {string}
     * @memberof Stadium
     */
    'nazov': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const StadiumForDownloadEnum = {
    Current: 'CURRENT',
    Previous: 'PREVIOUS',
    AnyPrevious: 'ANY_PREVIOUS'
} as const;

export type StadiumForDownloadEnum = typeof StadiumForDownloadEnum[keyof typeof StadiumForDownloadEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const StadiumMaterialuEnum = {
    FinalnePredbezneStanovisko: 'FINALNE_PREDBEZNE_STANOVISKO',
    Mpk: 'MPK',
    PredVyhlasenimVZbierke: 'PRED_VYHLASENIM_V_ZBIERKE',
    PredpripravnaFazaUkoncena: 'PREDPRIPRAVNA_FAZA_UKONCENA',
    PripravaMaterialu: 'PRIPRAVA_MATERIALU',
    PriradenieGestora: 'PRIRADENIE_GESTORA',
    ProcesUkonceny: 'PROCES_UKONCENY',
    RokovanieNrsr: 'ROKOVANIE_NRSR',
    RokovaniePov: 'ROKOVANIE_POV',
    RokovanieVlada: 'ROKOVANIE_VLADA',
    SchvalenieGestora: 'SCHVALENIE_GESTORA',
    SchvalovanieMinister: 'SCHVALOVANIE_MINISTER',
    SpracovaniePredkladatel: 'SPRACOVANIE_PREDKLADATEL',
    VyhlaseneVZbierke: 'VYHLASENE_V_ZBIERKE',
    VyhodnotenieMpk: 'VYHODNOTENIE_MPK',
    VyhodnotenieMpkAkty: 'VYHODNOTENIE_MPK_AKTY',
    Vyjadrenia: 'VYJADRENIA',
    ZapisStanoviska: 'ZAPIS_STANOVISKA',
    ZapisPredbeznehoStanoviska: 'ZAPIS_PREDBEZNEHO_STANOVISKA',
    ZapisDoplnenehoPredbeznehoStanoviska: 'ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA',
    AdministraciaProcesu: 'ADMINISTRACIA_PROCESU',
    AproximaciaNariadenia: 'APROXIMACIA_NARIADENIA',
    AproximaciaSmernice: 'APROXIMACIA_SMERNICE',
    ArchivovanyAeu: 'ARCHIVOVANY_AEU',
    CakajuciPubMod: 'CAKAJUCI_PUB_MOD',
    DoplneniePozicie: 'DOPLNENIE_POZICIE',
    FinalizaciaInstrukcie: 'FINALIZACIA_INSTRUKCIE',
    FinalizaciaNotifikacnychFormularov: 'FINALIZACIA_NOTIFIKACNYCH_FORMULAROV',
    FinalizaciaPozicie: 'FINALIZACIA_POZICIE',
    KontrolaRedakcUprav: 'KONTROLA_REDAKC_UPRAV',
    MzvEz: 'MZV_EZ',
    NotifikacnyFormular: 'NOTIFIKACNY_FORMULAR',
    OdoslaneRokovanieNrsr: 'ODOSLANE_ROKOVANIE_NRSR',
    OdoslaneRokovanieVlady: 'ODOSLANE_ROKOVANIE_VLADY',
    OdoslaneZz: 'ODOSLANE_ZZ',
    PredPublikovanim: 'PRED_PUBLIKOVANIM',
    PriebezneZapracovaniePrip: 'PRIEBEZNE_ZAPRACOVANIE_PRIP',
    PripomienkovaniePozmenNavrhovNrsr: 'PRIPOMIENKOVANIE_POZMEN_NAVRHOV_NRSR',
    PripravaMaterialuAdmin: 'PRIPRAVA_MATERIALU_ADMIN',
    PripravaMaterialuPi: 'PRIPRAVA_MATERIALU_PI',
    PripravaNelegMaterialu: 'PRIPRAVA_NELEG_MATERIALU',
    PriradenieGestoraCoreper: 'PRIRADENIE_GESTORA_COREPER',
    PriradenieGestoraNariadenie: 'PRIRADENIE_GESTORA_NARIADENIE',
    PriradenieGestoraRadaEu: 'PRIRADENIE_GESTORA_RADA_EU',
    PriradenieGestoraSmernica: 'PRIRADENIE_GESTORA_SMERNICA',
    PublikaciaRo: 'PUBLIKACIA_RO',
    RokovanieLrv: 'ROKOVANIE_LRV',
    RokovanieNrsrNelegMat: 'ROKOVANIE_NRSR_NELEG_MAT',
    RokovaniePracKomisii: 'ROKOVANIE_PRAC_KOMISII',
    RokovaniePredkladatel: 'ROKOVANIE_PREDKLADATEL',
    RokovaniePredkladatelNelegMat: 'ROKOVANIE_PREDKLADATEL_NELEG_MAT',
    RokovanieVladaNelegMat: 'ROKOVANIE_VLADA_NELEG_MAT',
    SefredaktorPridelovanie: 'SEFREDAKTOR_PRIDELOVANIE',
    SefredaktorSchvaleniePredPubmod: 'SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD',
    SefredaktorSchvaleniePredPubmodNelegMat: 'SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD_NELEG_MAT',
    SchvaleneNaVlade: 'SCHVALENE_NA_VLADE',
    SchvalovaniePrezident: 'SCHVALOVANIE_PREZIDENT',
    SpracovanieRedaktor: 'SPRACOVANIE_REDAKTOR',
    SpracovanieRedaktorNelegMat: 'SPRACOVANIE_REDAKTOR_NELEG_MAT',
    SpracovanieSefredaktor: 'SPRACOVANIE_SEFREDAKTOR',
    SpracovanieSefredaktorNelegMat: 'SPRACOVANIE_SEFREDAKTOR_NELEG_MAT',
    VyhodnotenieMpkNelegMat: 'VYHODNOTENIE_MPK_NELEG_MAT',
    VyhodnotenieRokovaniaNrsr: 'VYHODNOTENIE_ROKOVANIA_NRSR',
    VyhodnotenieVysledkuRokovania: 'VYHODNOTENIE_VYSLEDKU_ROKOVANIA',
    VyhodnotenieVysledkuRokovaniaNelegMat: 'VYHODNOTENIE_VYSLEDKU_ROKOVANIA_NELEG_MAT',
    VytvorenieCiastkovejInstrukcie: 'VYTVORENIE_CIASTKOVEJ_INSTRUKCIE',
    VytvoreniePozicie: 'VYTVORENIE_POZICIE',
    ZaevidovanieMaterialu: 'ZAEVIDOVANIE_MATERIALU',
    ZaevidovanieOpatrenia: 'ZAEVIDOVANIE_OPATRENIA'
} as const;

export type StadiumMaterialuEnum = typeof StadiumMaterialuEnum[keyof typeof StadiumMaterialuEnum];


/**
 * 
 * @export
 * @interface StadiumMaterialuHistoria
 */
export interface StadiumMaterialuHistoria {
    /**
     * 
     * @type {string}
     * @memberof StadiumMaterialuHistoria
     */
    'uuid': string;
    /**
     * 
     * @type {Stadium}
     * @memberof StadiumMaterialuHistoria
     */
    'stadium': Stadium;
    /**
     * 
     * @type {string}
     * @memberof StadiumMaterialuHistoria
     */
    'datumZacatia': string;
    /**
     * 
     * @type {string}
     * @memberof StadiumMaterialuHistoria
     */
    'datumUkoncenia'?: string;
    /**
     * 
     * @type {Organizacia}
     * @memberof StadiumMaterialuHistoria
     */
    'vlastnikAktivity'?: Organizacia;
}
/**
 * 
 * @export
 * @interface StadiumMaterialuHistoriaList
 */
export interface StadiumMaterialuHistoriaList {
    /**
     * 
     * @type {Array<StadiumMaterialuHistoria>}
     * @memberof StadiumMaterialuHistoriaList
     */
    'historiaRecords'?: Array<StadiumMaterialuHistoria>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const StavPripomienkyEnum = {
    Akceptovana: 'AKCEPTOVANA',
    CiastocneAkceptovana: 'CIASTOCNE_AKCEPTOVANA',
    Neakceptovana: 'NEAKCEPTOVANA',
    NeprihliadaSa: 'NEPRIHLIADA_SA',
    Nespracovana: 'NESPRACOVANA',
    Stornovana: 'STORNOVANA',
    Zrusena: 'ZRUSENA'
} as const;

export type StavPripomienkyEnum = typeof StavPripomienkyEnum[keyof typeof StavPripomienkyEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TypPripomienkyEnum = {
    Obycajna: 'OBYCAJNA',
    Zasadna: 'ZASADNA',
    Hromadna: 'HROMADNA'
} as const;

export type TypPripomienkyEnum = typeof TypPripomienkyEnum[keyof typeof TypPripomienkyEnum];


/**
 * 
 * @export
 * @interface VyhodnotenieMpkReportRequest
 */
export interface VyhodnotenieMpkReportRequest {
    /**
     * 
     * @type {string}
     * @memberof VyhodnotenieMpkReportRequest
     */
    'materialUuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VyhodnotenieMpkReportRequest
     */
    'nahladVyhodnotenia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VyhodnotenieMpkReportRequest
     */
    'useFilter'?: boolean;
    /**
     * 
     * @type {PripomienkaFilter}
     * @memberof VyhodnotenieMpkReportRequest
     */
    'filterRequest'?: PripomienkaFilter;
}

/**
 * LegislativnyMaterialGetReportPripomienkyApi - axios parameter creator
 * @export
 */
export const LegislativnyMaterialGetReportPripomienkyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Download report of vznesene pripomienky from MPK
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportPripomienky: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getReportPripomienky', 'uuid', uuid)
            const localVarPath = `/legislativne-materialy/{uuid}/reporty/pripomienky`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegislativnyMaterialGetReportPripomienkyApi - functional programming interface
 * @export
 */
export const LegislativnyMaterialGetReportPripomienkyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegislativnyMaterialGetReportPripomienkyApiAxiosParamCreator(configuration)
    return {
        /**
         * Download report of vznesene pripomienky from MPK
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportPripomienky(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportPripomienky(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegislativnyMaterialGetReportPripomienkyApi.getReportPripomienky']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegislativnyMaterialGetReportPripomienkyApi - factory interface
 * @export
 */
export const LegislativnyMaterialGetReportPripomienkyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegislativnyMaterialGetReportPripomienkyApiFp(configuration)
    return {
        /**
         * Download report of vznesene pripomienky from MPK
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportPripomienky(uuid: string, options?: any): AxiosPromise<string> {
            return localVarFp.getReportPripomienky(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegislativnyMaterialGetReportPripomienkyApi - object-oriented interface
 * @export
 * @class LegislativnyMaterialGetReportPripomienkyApi
 * @extends {BaseAPI}
 */
export class LegislativnyMaterialGetReportPripomienkyApi extends BaseAPI {
    /**
     * Download report of vznesene pripomienky from MPK
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegislativnyMaterialGetReportPripomienkyApi
     */
    public getReportPripomienky(uuid: string, options?: RawAxiosRequestConfig) {
        return LegislativnyMaterialGetReportPripomienkyApiFp(this.configuration).getReportPripomienky(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LegislativnyMaterialHistoriaApi - axios parameter creator
 * @export
 */
export const LegislativnyMaterialHistoriaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Getting all history records of the legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHistoriaRecords: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getAllHistoriaRecords', 'uuid', uuid)
            const localVarPath = `/legislativne-materialy/{uuid}/historia`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegislativnyMaterialHistoriaApi - functional programming interface
 * @export
 */
export const LegislativnyMaterialHistoriaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegislativnyMaterialHistoriaApiAxiosParamCreator(configuration)
    return {
        /**
         * Getting all history records of the legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllHistoriaRecords(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StadiumMaterialuHistoriaList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllHistoriaRecords(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegislativnyMaterialHistoriaApi.getAllHistoriaRecords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegislativnyMaterialHistoriaApi - factory interface
 * @export
 */
export const LegislativnyMaterialHistoriaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegislativnyMaterialHistoriaApiFp(configuration)
    return {
        /**
         * Getting all history records of the legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHistoriaRecords(uuid: string, options?: any): AxiosPromise<StadiumMaterialuHistoriaList> {
            return localVarFp.getAllHistoriaRecords(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegislativnyMaterialHistoriaApi - object-oriented interface
 * @export
 * @class LegislativnyMaterialHistoriaApi
 * @extends {BaseAPI}
 */
export class LegislativnyMaterialHistoriaApi extends BaseAPI {
    /**
     * Getting all history records of the legislativny material.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegislativnyMaterialHistoriaApi
     */
    public getAllHistoriaRecords(uuid: string, options?: RawAxiosRequestConfig) {
        return LegislativnyMaterialHistoriaApiFp(this.configuration).getAllHistoriaRecords(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportVyhodnotenieMpkApi - axios parameter creator
 * @export
 */
export const ReportVyhodnotenieMpkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Download report of vyhodnotenie MPK
         * @param {VyhodnotenieMpkReportRequest} vyhodnotenieMpkReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportVyhodnotenieMpk: async (vyhodnotenieMpkReportRequest: VyhodnotenieMpkReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vyhodnotenieMpkReportRequest' is not null or undefined
            assertParamExists('getReportVyhodnotenieMpk', 'vyhodnotenieMpkReportRequest', vyhodnotenieMpkReportRequest)
            const localVarPath = `/legislativne-materialy/reporty/vyhodnotenie-mpk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vyhodnotenieMpkReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportVyhodnotenieMpkApi - functional programming interface
 * @export
 */
export const ReportVyhodnotenieMpkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportVyhodnotenieMpkApiAxiosParamCreator(configuration)
    return {
        /**
         * Download report of vyhodnotenie MPK
         * @param {VyhodnotenieMpkReportRequest} vyhodnotenieMpkReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportVyhodnotenieMpk(vyhodnotenieMpkReportRequest: VyhodnotenieMpkReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportVyhodnotenieMpk(vyhodnotenieMpkReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportVyhodnotenieMpkApi.getReportVyhodnotenieMpk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportVyhodnotenieMpkApi - factory interface
 * @export
 */
export const ReportVyhodnotenieMpkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportVyhodnotenieMpkApiFp(configuration)
    return {
        /**
         * Download report of vyhodnotenie MPK
         * @param {VyhodnotenieMpkReportRequest} vyhodnotenieMpkReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportVyhodnotenieMpk(vyhodnotenieMpkReportRequest: VyhodnotenieMpkReportRequest, options?: any): AxiosPromise<string> {
            return localVarFp.getReportVyhodnotenieMpk(vyhodnotenieMpkReportRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportVyhodnotenieMpkApi - object-oriented interface
 * @export
 * @class ReportVyhodnotenieMpkApi
 * @extends {BaseAPI}
 */
export class ReportVyhodnotenieMpkApi extends BaseAPI {
    /**
     * Download report of vyhodnotenie MPK
     * @param {VyhodnotenieMpkReportRequest} vyhodnotenieMpkReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportVyhodnotenieMpkApi
     */
    public getReportVyhodnotenieMpk(vyhodnotenieMpkReportRequest: VyhodnotenieMpkReportRequest, options?: RawAxiosRequestConfig) {
        return ReportVyhodnotenieMpkApiFp(this.configuration).getReportVyhodnotenieMpk(vyhodnotenieMpkReportRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SprievodnyDokumentDownloadApi - axios parameter creator
 * @export
 */
export const SprievodnyDokumentDownloadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Download sprievodny dokument by typ for concrete legislativny material
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {StadiumForDownloadEnum} [fromStadium] Stadium from which document should be downloaded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSprievodnyDokumentByTyp: async (uuid: string, sprievodnyDokumentKod: string, fromStadium?: StadiumForDownloadEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('downloadSprievodnyDokumentByTyp', 'uuid', uuid)
            // verify required parameter 'sprievodnyDokumentKod' is not null or undefined
            assertParamExists('downloadSprievodnyDokumentByTyp', 'sprievodnyDokumentKod', sprievodnyDokumentKod)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/{sprievodnyDokumentKod}/download`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"sprievodnyDokumentKod"}}`, encodeURIComponent(String(sprievodnyDokumentKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromStadium !== undefined) {
                localVarQueryParameter['fromStadium'] = fromStadium;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SprievodnyDokumentDownloadApi - functional programming interface
 * @export
 */
export const SprievodnyDokumentDownloadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SprievodnyDokumentDownloadApiAxiosParamCreator(configuration)
    return {
        /**
         * Download sprievodny dokument by typ for concrete legislativny material
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {StadiumForDownloadEnum} [fromStadium] Stadium from which document should be downloaded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSprievodnyDokumentByTyp(uuid: string, sprievodnyDokumentKod: string, fromStadium?: StadiumForDownloadEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSprievodnyDokumentByTyp(uuid, sprievodnyDokumentKod, fromStadium, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentDownloadApi.downloadSprievodnyDokumentByTyp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SprievodnyDokumentDownloadApi - factory interface
 * @export
 */
export const SprievodnyDokumentDownloadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SprievodnyDokumentDownloadApiFp(configuration)
    return {
        /**
         * Download sprievodny dokument by typ for concrete legislativny material
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {StadiumForDownloadEnum} [fromStadium] Stadium from which document should be downloaded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSprievodnyDokumentByTyp(uuid: string, sprievodnyDokumentKod: string, fromStadium?: StadiumForDownloadEnum, options?: any): AxiosPromise<string> {
            return localVarFp.downloadSprievodnyDokumentByTyp(uuid, sprievodnyDokumentKod, fromStadium, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SprievodnyDokumentDownloadApi - object-oriented interface
 * @export
 * @class SprievodnyDokumentDownloadApi
 * @extends {BaseAPI}
 */
export class SprievodnyDokumentDownloadApi extends BaseAPI {
    /**
     * Download sprievodny dokument by typ for concrete legislativny material
     * @param {string} uuid Primary key of entity
     * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
     * @param {StadiumForDownloadEnum} [fromStadium] Stadium from which document should be downloaded
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentDownloadApi
     */
    public downloadSprievodnyDokumentByTyp(uuid: string, sprievodnyDokumentKod: string, fromStadium?: StadiumForDownloadEnum, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentDownloadApiFp(this.configuration).downloadSprievodnyDokumentByTyp(uuid, sprievodnyDokumentKod, fromStadium, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SprievodnyDokumentExistsApi - axios parameter creator
 * @export
 */
export const SprievodnyDokumentExistsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check if type of sprievodny dokument exists.
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existSprievodnyDokument: async (uuid: string, sprievodnyDokumentKod: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('existSprievodnyDokument', 'uuid', uuid)
            // verify required parameter 'sprievodnyDokumentKod' is not null or undefined
            assertParamExists('existSprievodnyDokument', 'sprievodnyDokumentKod', sprievodnyDokumentKod)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/{sprievodnyDokumentKod}/exists`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"sprievodnyDokumentKod"}}`, encodeURIComponent(String(sprievodnyDokumentKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if type of sprievodny dokument exists in current or any previous stadium.
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existSprievodnyDokumentInAnyStadium: async (uuid: string, sprievodnyDokumentKod: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('existSprievodnyDokumentInAnyStadium', 'uuid', uuid)
            // verify required parameter 'sprievodnyDokumentKod' is not null or undefined
            assertParamExists('existSprievodnyDokumentInAnyStadium', 'sprievodnyDokumentKod', sprievodnyDokumentKod)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/{sprievodnyDokumentKod}/exist-in-any-stadium`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"sprievodnyDokumentKod"}}`, encodeURIComponent(String(sprievodnyDokumentKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SprievodnyDokumentExistsApi - functional programming interface
 * @export
 */
export const SprievodnyDokumentExistsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SprievodnyDokumentExistsApiAxiosParamCreator(configuration)
    return {
        /**
         * Check if type of sprievodny dokument exists.
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existSprievodnyDokument(uuid: string, sprievodnyDokumentKod: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SprievodnyDokumentStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existSprievodnyDokument(uuid, sprievodnyDokumentKod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentExistsApi.existSprievodnyDokument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check if type of sprievodny dokument exists in current or any previous stadium.
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existSprievodnyDokumentInAnyStadium(uuid: string, sprievodnyDokumentKod: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SprievodnyDokumentStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existSprievodnyDokumentInAnyStadium(uuid, sprievodnyDokumentKod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentExistsApi.existSprievodnyDokumentInAnyStadium']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SprievodnyDokumentExistsApi - factory interface
 * @export
 */
export const SprievodnyDokumentExistsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SprievodnyDokumentExistsApiFp(configuration)
    return {
        /**
         * Check if type of sprievodny dokument exists.
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existSprievodnyDokument(uuid: string, sprievodnyDokumentKod: string, options?: any): AxiosPromise<SprievodnyDokumentStatus> {
            return localVarFp.existSprievodnyDokument(uuid, sprievodnyDokumentKod, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if type of sprievodny dokument exists in current or any previous stadium.
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existSprievodnyDokumentInAnyStadium(uuid: string, sprievodnyDokumentKod: string, options?: any): AxiosPromise<SprievodnyDokumentStatus> {
            return localVarFp.existSprievodnyDokumentInAnyStadium(uuid, sprievodnyDokumentKod, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SprievodnyDokumentExistsApi - object-oriented interface
 * @export
 * @class SprievodnyDokumentExistsApi
 * @extends {BaseAPI}
 */
export class SprievodnyDokumentExistsApi extends BaseAPI {
    /**
     * Check if type of sprievodny dokument exists.
     * @param {string} uuid Primary key of entity
     * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentExistsApi
     */
    public existSprievodnyDokument(uuid: string, sprievodnyDokumentKod: string, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentExistsApiFp(this.configuration).existSprievodnyDokument(uuid, sprievodnyDokumentKod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if type of sprievodny dokument exists in current or any previous stadium.
     * @param {string} uuid Primary key of entity
     * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentExistsApi
     */
    public existSprievodnyDokumentInAnyStadium(uuid: string, sprievodnyDokumentKod: string, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentExistsApiFp(this.configuration).existSprievodnyDokumentInAnyStadium(uuid, sprievodnyDokumentKod, options).then((request) => request(this.axios, this.basePath));
    }
}



